import request from '@/utils/ajax'


export function saveLineConfig(data) {
    return request({
        url: '/wx/manage/lineChannel/save',
        method: 'post',
        data: data
    })
}

export function editLineConfig(data) {
    return request({
        url: '/wx/manage/lineChannel/update',
        method: 'put',
        data: data
    })
}

export function deleteLineChanelConfig(data) {
    return request({
        url: '/wx/manage/lineChannel/delete',
        method: 'post',
        data: data
    })
}
